module.exports = __webpack_public_path__ + "img/rar.91679ba7.png";